import MapComponent from '../../../../../../common/components/organisme/MapComponent/MapComponent';
import styles from './LocationMapView.module.scss';

export interface LocationMapViewProps {
    lng?: number;
    lat?: number;
    namePin?: string;
}

export default function LocationMapView({lng, lat, namePin}: LocationMapViewProps) {
  return (
    <>
    { lng !== undefined && lat !== undefined &&
    <div className={styles['container']}>
        <MapComponent center={[lat, lng]}
                        zoom={13}
                        pinList={[{position: [lat, lng], name: namePin || lat + ' ' + lng}]}
        
        style={{height: '100%', width: '100%', borderRadius: '20px', position: 'relative'}}/>
    </div>
    }
    </>
  )
}
